import React from "react";
import TermsContainer from "./TermsContainer";
import Link from "next/link";

export default function LoyaltyTerms() {
  return (
    <TermsContainer>
      <h2>Loyalty Program Terms and Conditions</h2>

      <div className="mt-5">
        <p>Effective Date: March 5, 2022.</p>
      </div>

      <p>
        The Chic Beauty Box Loyalty Program (the “Program”) sponsored by Chic
        Beauty Inc. (“Chic Beauty Box.”) is designed to help you get the most
        out of your membership. We reward you for certain things you do on our
        website, for example: shop on www.chicbeautybox.com (the “Site”), refer
        friends to Chic Beauty Box, review products, complete surveys etc.
        Further, you may use the points you earn to purchase product in our
        stores! The following terms and conditions (these “Loyalty Program Terms
        and Conditions”) contain important information regarding the Program.
        Please read the following Loyalty Program Terms and Conditions
        carefully. These Loyalty Program Terms and Conditions are incorporated
        into the{" "}
        <Link href="/terms">
          <a className="styled-underlined-link">Site Terms and Conditions</a>
        </Link>
        . Acceptance of the Site Terms and Conditions includes acceptance of
        these Loyalty Program Terms and Conditions. These Loyalty Program Terms
        and Conditions are a binding agreement between you and Chic Beauty Box
        and will govern your participation in any and all Program offers.
      </p>
      <p>
        Participating in the Program entitles members (“Members”) to take
        advantage of certain Program rewards (“Rewards”) that may change from
        time to time and, which may be made available for limited times, all as
        determined by Chic Beauty Box in its sole discretion. Chic Beauty Box
        reserves the right to modify these Loyalty Program Terms and Conditions
        at any time, without notice to you, so it is important to check the
        Loyalty Program Terms and Conditions periodically. Participation in the
        Program or redemption of Rewards is considered acceptance of these
        Loyalty Program Terms and Conditions and any modified terms included
        therein.{" "}
        <strong>
          Upon notice, Chic Beauty Box may, in its sole and absolute discretion,
          cancel, change, suspend or modify any aspect of the Program or any
          Program Reward at any time, including the availability of any Program
          Reward.
        </strong>
      </p>
      <h3>Program Period</h3>
      <p>
        This Program will continue until terminated, suspended, modified, or
        converted to another rewards program by Chic Beauty Box (the "Program
        Period").
      </p>
      <h3>Eligibility</h3>
      <p>
        To become a Member of the Program, you must be of the age of majority in
        your province or state. To enroll in the Program, you simply need to
        have registered for a Chic Beauty Box account. You do not need to have a
        subscription to earn Points in the Program.
      </p>
      <h3>Earning Chic Beauty Box Points</h3>
      <p>
        Once you have become a Member, you can begin racking up loyalty points
        (“Points”) the following ways:
      </p>
      <ul>
        <li>
          <p>
            Shop — every time you purchase a full-size product from our shops
            (the “Shop”), you earn 1 Point for every whole $1 spent per order
            (excluding tax, shipping charges and fees).
          </p>
        </li>
        <li>
          <p>
            Reviews - when you review products on our website, you will earn 10
            points for each review. We reserve the right to reject any review
            where we feel an abuse of the Program has occurred. For example,
            reviewing a product 10 times in order to rack up 100 points will be
            quickly thwarted by our systems and/or support staff.
          </p>
        </li>
        <li>
          <p>
            Referrals - when you refer a friend to Chic Beauty Box and they make
            a purchase, you are awarded 100 points.
          </p>
        </li>
        <li>
          <p>
            Surveys - completing some surveys earn you points. The amount of
            points you earn by completing a survey can vary. Look out for more
            information and additional terms on the specific survey.
          </p>
        </li>
      </ul>
      <p>
        Upon notice, Chic Beauty Box reserves the right to suspend, terminate,
        revalue or modify, without liability to Members, all or part of the
        Points’ value structure and offers and any merchandise or service. Chic
        Beauty Box reserves the right to adjudicate all Points discrepancies in
        its sole discretion, and the Members agree to abide by any such
        adjudication. You can check your Chic Beauty Box Points balance on your{" "}
        <Link href="/rewards">
          <a className="styled-underlined-link">rewards page</a>
        </Link>
        .
      </p>
      <h3>Chic Beauty Box Points Redemption</h3>
      <p>
        The Points are redeemable towards purchases of full-size products on the
        Site in any increment. You can redeem your Points during the checkout
        process. You cannot use Points to purchase subscriptions.
      </p>
      <p>
        To redeem your Points, simply add items to your shopping cart, and click
        the “Checkout” button (if you’re not already signed in, the next screen
        will prompt you to sign in to your account). Continue through the
        checkout process. When you get to the Payment section, you’ll see an
        option that says “Use Loyalty Points” When you click it, you will see
        your points balance and its equivalent dollar value. To apply the Points
        to your order, click "Apply Loyalty Points" and the dollar value will be
        subtracted from your order total. <br />
        Points are available for redemption for the purchase of products only
        while supplies last. Product quantities may be limited. If you choose to
        apply Points to your purchase, you will not be able to select the amount
        of your Points that are applied to the order. If you have more Points
        than are necessary to complete a purchase, the appropriate number of
        Points will be applied and deducted from your account to complete the
        purchase; points not needed to complete the purchase will remain in your
        account. If you have Points in your account, but not enough to complete
        the purchase, all Points in your account will be applied to the
        purchase. You will be asked to select another form of payment to cover
        the remaining balance. Additionally, you'll be required to enter your
        credit card information regardless of whether you have enough points to
        complete the order or not. This is required for validation,
        authentication, and to prevent certain types of fraud.
      </p>
      <h3>Refunds &amp; Returns</h3>
      <p>
        Any items received as a result of Points redemption may only be
        exchanged for a refund of the applicable Points redeemed for such item
        (not cash or credit). Purchases made with Points will ship in the normal
        course of business.
        <br />
        Points earned via credit card transaction purchases on the Site will be
        rescinded in the event that such purchase is returned for a refund.
      </p>
      <h3>Chic Beauty Box Points Minimums And Maximum</h3>
      <p>
        You cannot redeem Points for more than the total amount of your
        purchase. Points are not redeemable for cash.
      </p>
      <h3>Chic Beauty Box Points Balance</h3>
      <p>
        You can always check your Chic Beauty Box Point balance in your{" "}
        <Link href="/account">
          <a className="styled-underlined-link">account</a>
        </Link>{" "}
        or on the{" "}
        <Link href="/rewards">
          <a className="styled-underlined-link">rewards page</a>
        </Link>
        .
      </p>
      <h3>Chic Beauty Box Points Expiration</h3>
      <p>
        Chic Beauty Box Points do not currently have an expiration date.
        However, there is a reasonable expectation that Points accrued will be
        used within one year from the date they were first earned.
      </p>
      <h3>Reward Conditions</h3>
      <p>
        Rewards may be taxable, depending on the value of the item and the
        federal, provincial, state, and/or local tax laws applicable to the
        Member. Members are solely responsible for reporting such items on their
        tax returns and paying any associated tax liability. Members may not
        assign or transfer any Rewards. Chic Beauty Box makes no warranty in any
        respect as to any Rewards, merchandise or service available within the
        Program.
      </p>
      <h3>Termination</h3>
      <p>
        Chic Beauty Box may, in its sole and absolute discretion, cancel,
        change, suspend, or modify any aspect of the Program and/or any Reward
        at any time, including the availability of any Reward. Chic Beauty Box
        may, in its sole and absolute discretion, terminate or suspend any
        Member’s participation in the Program for breach of these Loyalty
        Program Terms and Conditions, or for taking any actions that are
        inconsistent with the intent of these Loyalty Program Terms and
        Conditions. Chic Beauty Box reserves the right at its sole discretion to
        prohibit any Member from participating in any aspect of the Program if
        Chic Beauty Box deems or suspects that such Member has engaged in or has
        attempted to engage in any of the following: (a) acting in violation of
        these Loyalty Program Terms and Conditions; or (b) damaging, tampering
        with or corrupting the operation of the Program or Site; or (c) acting
        with intent to annoy, harass or abuse any other person; or (d) any
        inappropriate, uncooperative, disruptive, fraudulent, potentially
        fraudulent, or unusual behavior or activity; or (e) activity deemed in
        the sole discretion of Chic Beauty Box to be generally inconsistent with
        the intended operation of the Program. Any decision Chic Beauty Box
        makes relating to termination or suspension of any Member’s
        participation in the Program shall be final and binding in all respects.
        Chic Beauty Box shall be the sole determiner in cases of suspected
        abuse, fraud, or breach of these Loyalty Program Terms and Conditions or
        intent of these Loyalty Program Terms and Conditions.
      </p>
      <h3>Release</h3>
      <p>
        Except for willful misconduct or gross negligence on the part of Chic
        Beauty Box, by participating in the Program, Members release Chic Beauty
        Box, its parent company, subsidiaries, affiliates, suppliers,
        advertising and promotions agencies and their respective directors,
        officers, employees, and agents (collectively, “Released Parties”) from
        any and all liability for any loss, harm, damages, cost or expense,
        including, without limitation, property damages, personal injury and/or
        death, arising out of or in any way connected to the Program or the use
        of any Rewards.
      </p>
    </TermsContainer>
  );
}
